// extracted by mini-css-extract-plugin
export var active = "productfinder-amber-module--active--9a022";
export var error_message = "productfinder-amber-module--error_message--be267";
export var infoBox = "productfinder-amber-module--infoBox--56f92";
export var input_section = "productfinder-amber-module--input_section--b05a4";
export var map_styles = "productfinder-amber-module--map_styles--98fd2";
export var product_category_container = "productfinder-amber-module--product_category_container--2a83a";
export var product_results = "productfinder-amber-module--product_results--29b56";
export var scroll = "productfinder-amber-module--scroll--26ba5";
export var search = "productfinder-amber-module--search--daed3";
export var search_section = "productfinder-amber-module--search_section--2d427";
export var two_columns = "productfinder-amber-module--two_columns--abb7d";